export default __webpack_public_path__ + "static/media/expl-nn_14_DE.8af3f85a.png";